import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const defEventsGoals = {
    before: AppConstants.GOALS_SEARCH_START_LOADING,
    success: AppConstants.GOALS_SEARCH_SUCCESS,
    fail: AppConstants.GOALS_SEARCH_FAIL
};

const defEventsAdvertisers = {
    before: AppConstants.ADVERTISERS_SEARCH_LOADING_START,
    success: AppConstants.ADVERTISERS_SEARCH_SUCCESS,
    fail: AppConstants.ADVERTISERS_SEARCH_FAIL
};

const defEventsPeriods = {
    before: AppConstants.PERIODS_SEARCH_LOADING_START,
    success: AppConstants.PERIODS_SEARCH_SUCCESS,
    fail: AppConstants.PERIODS_SEARCH_FAIL
};

const defEventsOffers = {
    before: AppConstants.OFFERS_SEARCH_START_LOADING,
    success: AppConstants.OFFERS_SEARCH_SUCCESS,
    fail: AppConstants.OFFERS_SEARCH_FAIL
};

const defEventsReferrers = {
    before: AppConstants.REFERRERS_SEARCH_START_LOADING,
    success: AppConstants.REFERRERS_SEARCH_SUCCESS,
    fail: AppConstants.REFERRERS_SEARCH_FAIL
};

const defEventsReferrals = {
    before: AppConstants.REFERRALS_SEARCH_START_LOADING,
    success: AppConstants.REFERRALS_SEARCH_SUCCESS,
    fail: AppConstants.REFERRALS_SEARCH_FAIL
};

const defEventsOffersReferrer = {
    before: AppConstants.OFFERS_REFERRER_SEARCH_START_LOADING,
    success: AppConstants.OFFERS_REFERRER_SEARCH_SUCCESS,
    fail: AppConstants.OFFERS_REFERRER_SEARCH_FAIL
};

const defEventsAdvertisersReferrer = {
    before: AppConstants.ADVERTISERS_REFERRER_SEARCH_START_LOADING,
    success: AppConstants.ADVERTISERS_REFERRER_SEARCH_SUCCESS,
    fail: AppConstants.ADVERTISERS_REFERRER_SEARCH_FAIL
};

const defEventsUtms = {
    before: AppConstants.UTMS_SEARCH_START_LOADING,
    success: AppConstants.UTMS_SEARCH_SUCCESS,
    fail: AppConstants.UTMS_SEARCH_FAIL
};

const defEventsReactivation = {
    before: AppConstants.REACTIVATION_SEARCH_START_LOADING,
    success: AppConstants.REACTIVATION_SEARCH_SUCCESS,
    fail: AppConstants.REACTIVATION_SEARCH_FAIL
};

const defEventsConversion = {
    before: AppConstants.CONVERSION_SEARCH_START_LOADING,
    success: AppConstants.CONVERSION_SEARCH_SUCCESS
};

const defEventsConversionTotal = {
    before: AppConstants.CONVERSION_GET_TOTAL_LOADING,
    success: AppConstants.CONVERSION_GET_TOTAL_SUCCESS
};

const defEventsFinanceOperation = {
    before: AppConstants.FINANCE_OPERATION_SEARCH_START_LOADING,
    success: AppConstants.FINANCE_OPERATION_SEARCH_SUCCESS
};

const defEventsPaymentDetails = {
    before: AppConstants.PAYMENT_DETAILS_SEARCH_START_LOADING,
    success: AppConstants.PAYMENT_DETAILS_SEARCH_SUCCESS,
};

const PublisherActions = {

    getCreativeType(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativeType(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativeLink(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativeLink(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativeContainer(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativeContainer(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativeBanner(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativeBanner(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativeLanding(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativeLanding(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCreativePromoCode(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCreativePromoCode(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getReactivationUnactivePeriod(params, callback, events = defEventsReactivation) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchReactivationUnactivePeriod(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getReactivationParam2(params, callback, events = defEventsReactivation) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchReactivationParam2(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getReactivationUtmMedium(params, callback, events = defEventsReactivation) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchReactivationUtmMedium(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getReactivationUtmSource(params, callback, events = defEventsReactivation) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchReactivationUtmSource(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getReactivationUtmCampaign(params, callback, events = defEventsReactivation) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchReactivationUtmCampaign(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getReactivationUtmTerm(params, callback, events = defEventsReactivation) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchReactivationUtmTerm(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getReactivationUtmContent(params, callback, events = defEventsReactivation) {
        events.before && dispatch({
            type: events.before
        });

        return api.searcReactivationhUtmContent(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getUtmMedium(params, callback, events = defEventsUtms) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchUtmMedium(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getUtmSource(params, callback, events = defEventsUtms) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchUtmSource(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getUtmCampaign(params, callback, events = defEventsUtms) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchUtmCampaign(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getUtmTerm(params, callback, events = defEventsUtms) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchUtmTerm(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getUtmContent(params, callback, events = defEventsUtms) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchUtmContent(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getOffers(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchOffers(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getCountries(params, callback, events = defEventsOffers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchCountries(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getReferrers(params, callback, events = defEventsReferrers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchReferrers(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getReferrals(params, callback, events = defEventsReferrals) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchReferrals(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getOffersReferrer(params, callback, events = defEventsOffersReferrer) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchOffersReferrer(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getAdvertisersReferrer(params, callback, events = defEventsAdvertisersReferrer) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchAdvertisersReferrer(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getGoals(params, callback, events = defEventsGoals) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchGoals(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getRanks() {
        api.getPublisherRanks()
            .then(data => {
                dispatch({
                    type  : AppConstants.PUBLISHER_RANKS_LOAD_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.PUBLISHER_RANKS_LOAD_FAIL,
                        error: err
                    });
                });
            });
    },

    getContactTypes() {
        api.getContactTypes()
            .then(data => {
                dispatch({
                    type  : AppConstants.PUBLISHER_CONTACT_TYPES_LOAD_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.PUBLISHER_CONTACT_TYPES_LOAD_FAIL,
                        error: err
                    });
                });
            });
    },

    getTimezonesList() {
        api.getTimezonesList()
            .then(data => {
                dispatch({
                    type  : AppConstants.PUBLISHER_TIMEZONES_LIST_LOAD_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.PUBLISHER_TIMEZONES_LIST_LOAD_FAIL,
                        error: err
                    });
                });
            });
    },

    getGoalEntries(params, callback) {
        dispatch({
            type  : AppConstants.GOAL_ENTRIES_SEARCH_LOADING_START
        });

        return api.searchGoalEntries(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.GOAL_ENTRIES_SEARCH_SUCCESS,
                    items : data.response || {}
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.GOAL_ENTRIES_SEARCH_FAIL,
                        error: err
                    });
                });
            });

    },

    getAdvertisers(params, callback, events = defEventsAdvertisers) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchAdvertisers(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    getPeriods(params, callback, events = defEventsPeriods) {
        events.before && dispatch({
            type: events.before
        });

        return api.searchPeriods(params)
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    edit(params) {
        return api.editPublisher(params);
    },

    getAccountEntries(params) {
        dispatch({
            type  : AppConstants.ACCOUNT_ENTRIES_START_LOADING
        });

        return api.searchAccountEntries(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.ACCOUNT_ENTRIES_SEARCH_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err);
            });
    },

    getPaymentDetails(params, callback, events = defEventsPaymentDetails) {
        // normalize signature: (params?, callback?, events?)
        let normalizedParams = params;
        let normalizedCallback = callback;
        let normalizedEvents = events;

        if (typeof params === 'function') {
            normalizedCallback = params;
            normalizedParams = undefined;
            normalizedEvents = callback || defEventsPaymentDetails;
        } else if (callback && typeof callback === 'object' && !Array.isArray(callback)) {
            normalizedEvents = callback;
            normalizedCallback = undefined;
        }

        dispatch({
            type  : normalizedEvents.before
        });

        return api.searchPublisherPaymentDetails(normalizedParams)
            .then(data => {
                dispatch({
                    type  : normalizedEvents.success,
                    items : data.response || {}
                });

                normalizedCallback && normalizedCallback(data.response);
            })
            .catch(err => {
                handleError(err);
            });
    },

    getTotalRows(params, callback, events = defEventsConversionTotal) {
        dispatch({
            type  : events.before
        });

        if(!params.created_at_from || !params.created_at_to) {
            return {};
        }

        return api.searchConversionTotalRows(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback();

                PublisherActions.getConversions(params);

                return data.response || {};
            })
            .catch(err => {
                handleError(err);
            });
    },

    getConversions(params, callback, events = defEventsConversion) {
        dispatch({
            type  : events.before
        });

        return api.searchConversions(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback();

                return data.response || {};
            })
            .catch(err => {
                handleError(err);
            });
    },

    getFinanceOperations(params, callback, events = defEventsFinanceOperation) {
        dispatch({
            type  : events.before
        });

        return api.searchFinanceOperations(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback();

                return data.response || {};
            })
            .catch(err => {
                handleError(err);
            });
    },

    sendActivationCode(params) {
        dispatch({
            type  : AppConstants.PAYMENT_DETAILS_SEND_ACTIVATION_CODE_START_LOADING
        });

        return api.sendActivationCodePublisherPaymentDetails(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.PAYMENT_DETAILS_SEND_ACTIVATION_CODE_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.PAYMENT_DETAILS_SEND_ACTIVATION_CODE_FAIL,
                        error: err
                    });
                });
            });
    },
};

export default PublisherActions;
